module.exports = __webpack_public_path__ + "static/flags/DJ-8f84715ad67e69a5ca7fe976e736920c.gif";